import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemSaturationOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-saturation-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

export function SlideshowItemSaturationOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const itemSaturation = useGetKeyFromEffectsOfActiveSlideItem('saturation');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (itemSaturation === undefined) {
    throw new Error('blackandwhite is undefined for active slide item');
  }

  const updateSaturation = (saturation: number, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        effects: {
          saturation,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemSaturationOption saturation={itemSaturation} updateSaturation={updateSaturation} />;
}
